import { Button, Divider, Form, Input, Spin } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import React from 'react';
import { useTranslation } from 'react-i18next';

import GlobalLan from '@/components/layout/global-lan';

import styles from './index.module.less';

interface Props {
  larkLoading: boolean;
  loading: boolean;
  form: FormInstance;
  handlelogin: (data: any) => void;
  onClickLarkLogin: () => void;
}

const PCLogin: React.FC<Props> = (props: Props) => {
  const { form, handlelogin, larkLoading, loading, onClickLarkLogin } = props;
  const { t } = useTranslation();

  const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };

  return (
    <div className={styles['pc-container']}>
      <div className={styles.logo}></div>
      <div className={styles['login-panel']}>
        <div className={styles['app-name']}>{t('APP NAME')}</div>
        <div className={styles.panel}>
          <div className={styles.language}>
            <GlobalLan />
          </div>
          <div className={styles.left}>
            <div className={styles.title}>{t('Inner user')}</div>
            <Spin spinning={larkLoading}>
              <div className={styles['lark-login']} onClick={onClickLarkLogin}>
                <img src="https://techcenter-common-storage.123u.com/public/feishu.png" />
              </div>
            </Spin>

            <div className={styles['inner-tips']}>{t('Login.Inner tips')}</div>
          </div>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <div className={styles.right}>
            <div className={styles.title}>{t('Out user')}</div>
            <Form
              form={form}
              name="login"
              initialValues={{ remember: true }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  form.submit();
                }
              }}
              onFinish={(e) => {
                handlelogin(e);
              }}
            >
              <Form.Item
                {...formItemLayout}
                name="email"
                rules={[
                  {
                    required: true,
                    message: t('Login.Please input account'),
                  },
                ]}
              >
                <Input placeholder={t('Login.Please input account')} />
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                name="password"
                rules={[
                  {
                    required: true,
                    message: t('Login.Please input pwd'),
                  },
                ]}
              >
                <Input.Password placeholder={t('Login.Please input pwd')} type="password" />
              </Form.Item>
              <Form.Item>
                <Button
                  id="login-btn"
                  className={styles['login-btn']}
                  onClick={() => form.submit()}
                  loading={loading}
                >
                  {t('Login.Login')}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PCLogin);
